import Form from '../_form';

export default class SignUpForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        const heading = document.querySelector('#sign-up-heading');
        if (!heading) throw new Error('Sign up heading element not found!');

        const staticImage = document.querySelector('#sign-up-image-static');
        if (!staticImage) throw new Error('Sign up image element not found!');

        const successImage = document.querySelector('#sign-up-image-success');
        if (!successImage) throw new Error('Sign up image element not found!');

        const success = document.querySelector('#sign-up-success');
        if (!success) throw new Error('Sign up success element not found!');

        this.success = success;
        this.successImage = successImage;
        this.staticImage = staticImage;
        this.heading = heading;
    }

    handleSuccess () {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
        this.heading.classList.add('hidden');
        this.staticImage.classList.add('hidden');
        this.successImage.classList.remove('hidden');
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const nonce = formData.get('sign_up_nonce');

        const firstname = formData.get('first-name');
        const lastname = formData.get('last-name');
        const email = formData.get('email');
        const password = formData.get('password');

        try {
            await fetch('/wp-json/auth/v1/sign-up', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nonce, firstname, lastname, email, password })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully signed up!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.handleSuccess();
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
